import { Link } from "react-router";
import { LegalPage } from "./LegalPage";

const p = (text: React.ReactNode) => (
    <p style={{ margin: "0 0 12px" }}>{text}</p>
);

const ul = (items: string[]) => (
    <ul style={{ margin: "8px 0 12px", paddingLeft: 20, display: "flex", flexDirection: "column", gap: 6 }}>
        {items.map((item, i) => <li key={i}>{item}</li>)}
    </ul>
);

const SECTIONS = [
    {
        id: "intro",
        title: "Acuerdo de uso",
        content: <>{p("Cualquier uso de las páginas Web de este sitio constituye un acuerdo por parte de los usuarios en aceptar los términos y condiciones descritos en este documento. Nos reservamos el derecho, a nuestra sola discreción, de cambiar, modificar, añadir o eliminar porciones de estos términos en cualquier momento. Por favor, consulte estos términos periódicamente para posibles cambios.")}</>
    },
    {
        id: "participacion",
        title: "1. Participación en el sitio",
        content: <>
            {p("HeyDoctor, por ser una comunidad interactiva, promueve la participación de los usuarios con personal médico altamente calificado.")}
            {p("Al participar de manera interactiva, está comprometido a no enviar o transmitir contenido que:")}
            {ul([
                "Induzca, incite o realice cualquier acto que constituya un delito.",
                "Incite a involucrarse en actividades peligrosas, ilegales o que atenten contra la salud física y emocional.",
                "Altere el equilibrio psíquico de las personas, las amedrente, atemorice o intimide.",
                "Infrinja las normas legales y/o transgrede los derechos de las personas.",
                "Sea discriminatorio en cuanto al sexo, religión, raza o cualquier otra violación a los derechos fundamentales.",
                "Proporcione datos y/o información falsa o parcial.",
                "Incorpore elementos ilícitos, violentos, de odio, pornográficos, obscenos o degradantes.",
                "Altere o envíe información que contenga virus u otras características que causen deterioro a los equipos.",
                "Realice publicidad, cadenas de mensajes, SPAM, etc.",
            ])}
            {p("HeyDoctor se reserva el derecho de no otorgar el servicio a cualquier usuario que no se ajuste a este acuerdo y podrá, sin previo aviso, suspender y/o interrumpir el servicio.")}
        </>
    },
    {
        id: "contenidos-propios",
        title: "2. De los contenidos propios",
        content: <>
            {p("HeyDoctor otorga a los usuarios contenidos propios de la empresa, así como conocimientos en materia de medicina. Dicho contenido no puede ser usado por otra persona ajena a la que recibe el servicio. Queda estrictamente prohibida la reproducción, total o parcial del servicio prestado.")}
            {p("HeyDoctor no se hace responsable por las posibles afecciones que pudiera sufrir el usuario, lo anterior debido a que la empresa no cuenta con la certeza de que el usuario lleve a cabo las recomendaciones recibidas dentro de la consulta.")}
            {p("A partir de la segunda consulta, la empresa contará con un antecedente que otorga la posibilidad de dar un seguimiento adecuado; sin embargo, la responsabilidad de llevar a cabo las recomendaciones emitidas seguirá siendo del usuario.")}
        </>
    },
    {
        id: "contenidos-terceros",
        title: "3. De los contenidos de terceros",
        content: <>
            {p("HeyDoctor advierte que dentro del portal existirá contenido publicado por terceros, correspondiente a espacios publicitarios, los cuales, al no ser titularidad de la empresa, pueden presentar errores, falsedades, no estar actualizados, o presentar vínculos rotos.")}
            {p("La publicación de contenidos de terceros no representa de ningún modo la opinión, intención, ideología, filosofía o proceder de HeyDoctor.")}
        </>
    },
    {
        id: "copyright",
        title: "4. Copyright y uso de los contenidos",
        content: <>
            {p("HeyDoctor no cuenta con contenidos descargables, por lo que el usuario no puede hacer uso bajo ninguna circunstancia de la información contenida dentro del portal.")}
            {p("Como excepción, la empresa podrá enviar al usuario documentos que incluyan recomendaciones y/o consejos como complemento a la consulta. El uso que se le dé a dicha información será única y exclusivamente responsabilidad del usuario.")}
        </>
    },
    {
        id: "privacidad",
        title: "5. Política de privacidad",
        content: <>
            {p("HeyDoctor tiene un compromiso público con sus usuarios de hacer un uso correcto de los datos ingresados por los mismos, ya sea al abrir una cuenta, al suscribirse a alguna lista de correo o boletín o al adquirir cualquier servicio.")}
            <p style={{ margin: "0 0 12px" }}>
                Para más información consulte el{" "}
                <Link to="/aviso-de-privacidad" style={{ color: "#4abcc9", fontWeight: 600 }}>Aviso de Privacidad</Link>.
            </p>
        </>
    },
    {
        id: "responsabilidad",
        title: "6. Responsabilidad",
        content: <>
            {p("HeyDoctor no se hace responsable por las interpretaciones de sus contenidos ni del uso indebido de los mismos.")}
            {p("Tampoco se responsabilizará por los daños o perjuicios, directos o indirectos, a consecuencia de la suspensión o terminación de los servicios, contenido y/o información que suministra a través de su sitio web.")}
            {p("El usuario se compromete a defender, desagraviar, reparar, exonerar e indemnizar a HeyDoctor y a todos sus directivos, empleados, representantes, agentes y socios, por cualquiera o todos los reclamos, demandas, daños y perjuicios derivados del uso que realice del sitio Web.")}
        </>
    },
    {
        id: "cookies",
        title: "7. Cookies",
        content: <>
            {p("HeyDoctor utiliza cookies en el sitio para mantener un mejor servicio. Dichos cookies son para trabajar de forma más dinámica, de manera que los usuarios puedan mantener una accesibilidad a los servicios con la menor dificultad posible y con un mejor desempeño.")}
            {p("De ninguna manera los cookies serán utilizados para recopilar información adicional de los usuarios ni exponer su privacidad ante ningún tercero.")}
        </>
    },
    {
        id: "ip",
        title: "8. Direcciones IP",
        content: <>{p("HeyDoctor registra la dirección IP para fines exclusivamente internos, tales como estadísticas y segmentación del mercado. Esto nos permite tener un mejor panorama de nuestros visitantes y nos ayuda a mejorar de acuerdo a las necesidades mostradas.")}</>
    },
    {
        id: "seguridad",
        title: "9. Seguridad",
        content: <>{p("HeyDoctor hace lo que está a su alcance para que la información de los usuarios esté lo menos expuesta posible al público en general. Sin embargo, HeyDoctor no puede garantizar que estos datos no estén expuestos a ataques de delincuentes informáticos o robos que puedan sufrir al estar almacenados en un servidor.")}</>
    },
    {
        id: "atencion",
        title: "10. Atención Personalizada",
        content: <>
            {p("Para llevar a cabo una atención personalizada respecto a los servicios, nos ponemos a su disposición en:")}
            <div style={{ background: "#f8fbff", borderRadius: 10, padding: "14px 18px", border: "1.5px solid #eef2f7", fontSize: "0.88rem" }}>
                <strong>Av. Cuauhtémoc 271</strong> int 101 · 102, Col. Roma,<br />
                Delegación Cuauhtémoc, C.P. 06700, Ciudad de México<br />
                <a href="mailto:contacto@heydoctor.com.mx" style={{ color: "#4abcc9" }}>contacto@heydoctor.com.mx</a> · (52 55) 55840843
            </div>
        </>
    },
];

export default function TerminosCondicionesPage() {
    return (
        <LegalPage
            badge="Documento Legal"
            title="Términos y Condiciones"
            subtitle="Lee detenidamente nuestros términos antes de usar la plataforma. Al utilizar HeyDoctor, aceptas las condiciones descritas en este documento."
            icon="gavel"
            sections={SECTIONS}
        />
    );
}
